export default "__VITE_ASSET__BmSATP9h__"